import {
  LayoutDashboard, FileText, Receipt, Inbox, Briefcase, CalendarDays, Clock, StickyNote, Wallet, Calculator,
  Landmark, CalendarClock, Images, LayoutGrid, Film, Sparkles, Ruler, GalleryHorizontal, Wrench, Truck, Settings,
  ShieldCheck, PoundSterling, BarChart3, Users,
} from 'lucide-react';

export const WORKSPACE_GROUPS = [
  { id: 'overview', label: 'Overview', items: [
    { to: '/workspace', label: 'Dashboard', Icon: LayoutDashboard, tid: 'ws-dashboard' },
  ] },
  { id: 'sales', label: 'Sales & customers', items: [
    { to: '/dashboard', label: 'Quotes', Icon: FileText, tid: 'ws-quotes', match: ['/dashboard', '/estimator'] },
    { to: '/customers', label: 'Customers', Icon: Users, tid: 'ws-customers' },
    { to: '/invoices', label: 'Invoices', Icon: Receipt, tid: 'ws-invoices' },
    { to: '/business?tab=enquiries', label: 'Enquiries', Icon: Inbox, tid: 'ws-enquiries' },
  ] },
  { id: 'jobs', label: 'Jobs & planning', items: [
    { to: '/jobs', label: 'Job Tracker', Icon: Briefcase, tid: 'ws-jobs' },
    { to: '/business?tab=calendar', label: 'Calendar', Icon: CalendarDays, tid: 'ws-calendar' },
    { to: '/timesheets', label: 'Hours', Icon: Clock, tid: 'ws-hours' },
    { to: '/notes', label: 'Notes', Icon: StickyNote, tid: 'ws-notes' },
  ] },
  { id: 'finance', label: 'Finance', items: [
    { to: '/receipts', label: 'Receipts', Icon: Wallet, tid: 'ws-receipts' },
    { to: '/vat-return', label: 'VAT Return', Icon: Landmark, tid: 'ws-vat' },
    { to: '/business?tab=tax', label: 'Tax Dates', Icon: CalendarClock, tid: 'ws-tax' },
    { to: '/trades/business-essentials', label: 'Overheads', Icon: PoundSterling, tid: 'ws-overheads' },
  ] },
  { id: 'creative', label: 'Creative studio', items: [
    { to: '/plan-designer', label: 'Plan Designer', Icon: Ruler, tid: 'ws-plan' },
    { to: '/design', label: 'AI Visualiser', Icon: Sparkles, tid: 'ws-visualiser' },
    { to: '/before-after', label: 'Before & After', Icon: Images, tid: 'ws-beforeafter' },
    { to: '/collage', label: 'Collage', Icon: LayoutGrid, tid: 'ws-collage' },
    { to: '/before-after-video', label: 'B&A Video', Icon: Film, tid: 'ws-bavideo' },
    { to: '/gallery', label: 'Gallery', Icon: GalleryHorizontal, tid: 'ws-gallery' },
  ] },
  { id: 'assets', label: 'Assets', items: [
    { to: '/business?tab=tools', label: 'Tools', Icon: Wrench, tid: 'ws-tools' },
    { to: '/business?tab=vans', label: 'Vans', Icon: Truck, tid: 'ws-vans' },
  ] },
  { id: 'account', label: 'Account', items: [
    { to: '/settings', label: 'Settings', Icon: Settings, tid: 'ws-settings' },
  ] },
];

export const ADMIN_GROUP = { id: 'admin', label: 'Admin', items: [
  { to: '/admin', label: 'Admin', Icon: ShieldCheck, tid: 'ws-admin' },
  { to: '/admin/analytics', label: 'Analytics', Icon: BarChart3, tid: 'ws-analytics' },
] };

export const PUBLIC_TOOLS = [
  { to: '/calculators', label: 'Calculators', Icon: Calculator },
  { to: '/estimator', label: 'New quote', Icon: FileText },
];

const WS_PREFIXES = ['/workspace', '/customers', '/trades/business-essentials', '/dashboard', '/estimator', '/invoices', '/business', '/jobs', '/timesheets', '/notes', '/receipts',
  '/vat-return', '/overheads', '/plan-designer', '/design', '/before-after', '/collage', '/gallery', '/settings', '/admin'];

export const isWorkspacePath = (path) => WS_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`) || (p === '/before-after' && path === '/before-after-video'));

export function isItemActive(item, pathname, search) {
  const [path, query] = item.to.split('?');
  if (query) return pathname === path && search.includes(query);
  if (pathname === '/business') return false;
  const paths = item.match || [path];
  return paths.some((p) => pathname === p || (p !== '/admin' && pathname.startsWith(`${p}/`)) || (p === '/admin' && pathname === '/admin'));
}
